// ログイン・会員登録の後の戻り先（return_to）を扱う共通処理。
// 外部サイトへのリダイレクトを防ぐため、同じサイト内の URL の path + search だけを受け付ける。
const POST_AUTH_RETURN_TO_KEY = 'postAuthReturnTo';

function getSafeReturnTo(returnTo) {
  if (!returnTo) return null;

  let url;
  try {
    url = new URL(returnTo, window.location.origin);
  } catch (_) {
    return null;
  }
  if (url.origin !== window.location.origin) return null;
  // '/.//evil.com' などは origin が同じでも pathname が '//evil.com' になり、href に入れると外部サイトへ飛ぶので弾く
  if (url.pathname.startsWith('//')) return null;

  return url.pathname + url.search;
}

// カートやレビューのページからは Shopify 標準の return_url でログイン画面に来るので、return_to が無ければそちらを読む
function getSafeReturnToFromUrl() {
  const params = new URLSearchParams(window.location.search);
  return getSafeReturnTo(params.get('return_to') || params.get('return_url'));
}

// 会員登録は /account/register → #update-information → #update-completed と進み、途中で URL の return_to が消える。
// そのため戻り先はタブ単位（sessionStorage）で覚えておき、登録完了画面で使う。
function savePostAuthReturnTo(returnTo) {
  const safeReturnTo = getSafeReturnTo(returnTo);
  if (!safeReturnTo) return;

  try {
    sessionStorage.setItem(POST_AUTH_RETURN_TO_KEY, safeReturnTo);
  } catch (_) {
    // プライベートブラウズなどで保存できないときは、従来どおり戻り先なしで進む
  }
}

function loadPostAuthReturnTo() {
  try {
    return getSafeReturnTo(sessionStorage.getItem(POST_AUTH_RETURN_TO_KEY));
  } catch (_) {
    return null;
  }
}

function clearPostAuthReturnTo() {
  try {
    sessionStorage.removeItem(POST_AUTH_RETURN_TO_KEY);
  } catch (_) {
    // 保存できない環境では何も残っていない
  }
}

// 今いるページ（path + search）を、ログイン・会員登録の後の戻り先として返す。
// マイページ（/account 〜）はログイン後の既定の行き先と同じなので、戻り先にしない。
function getCurrentPageReturnTo() {
  const returnTo = getSafeReturnTo(window.location.pathname + window.location.search);
  if (!returnTo || returnTo.startsWith('/account')) return null;

  return returnTo;
}

// data-auth-return-to を付けたログイン・会員登録のリンクに、今いるページを return_to として付ける
function setAuthLinkReturnTo(link) {
  const url = new URL(link.getAttribute('href'), window.location.origin);
  const returnTo = getCurrentPageReturnTo();
  if (returnTo) {
    url.searchParams.set('return_to', returnTo);
  } else {
    url.searchParams.delete('return_to');
  }
  link.setAttribute('href', url.pathname + url.search);
}

document.addEventListener('DOMContentLoaded', function () {
  // ヘッダー・モバイルメニューのログイン／会員登録
  document.querySelectorAll('a[data-auth-return-to]').forEach(setAuthLinkReturnTo);

  // ログインが必要なときのモーダル（サンプル請求・見積もり・お気に入りなど）は、開いた時点のページを戻り先にする
  const confirmLoginModal = document.getElementById('confirmLoginModal');
  if (confirmLoginModal) {
    confirmLoginModal.addEventListener('show.bs.modal', function () {
      confirmLoginModal.querySelectorAll('a[data-auth-return-to]').forEach(setAuthLinkReturnTo);
    });
  }
});

// 会員登録の1段目で一時的に残したログイン情報（script.register.js の userInfoHash）は、2段目（/account/register#update-information）でしか使わない。
// - 以前の版が localStorage に残したもの（登録を終えた後も残っていることがある）は、どのページでも消す。今の版は localStorage に書かない
// - sessionStorage のものは、会員登録ページ（2段目の判定は script.register.js が行う）と、送信の途中で出る Shopify の確認画面（/challenge）以外を開いたら消す。
//   /challenge でも、保存から10分（script.register.js の USER_INFO_HASH_TTL_MS）を過ぎていれば消す
// シミュレーター系のページ（no-header-footer レイアウト）はこのファイルを読み込まないので、script.common.js でも同じように消す
(function clearRegistrationUserInfoHash() {
  const userInfoHashKey = 'userInfoHash';
  const userInfoHashTtlMs = 10 * 60 * 1000;

  try {
    localStorage.removeItem(userInfoHashKey);
  } catch (_) {
    // 保存できない環境では何も残っていない
  }

  const path = window.location.pathname;
  if (/\/account\/register\/?$/.test(path)) return;
  if (/\/challenge\/?$/.test(path) && !isUserInfoHashExpired()) return;

  try {
    sessionStorage.removeItem(userInfoHashKey);
  } catch (_) {
    // 保存できない環境では何も残っていない
  }

  // 無い・壊れている・期限切れのときは true
  function isUserInfoHashExpired() {
    try {
      const stash = JSON.parse(sessionStorage.getItem(userInfoHashKey));
      return !stash || typeof stash.savedAt !== 'number' || Date.now() - stash.savedAt > userInfoHashTtlMs;
    } catch (_) {
      return true;
    }
  }
})();
